// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const InStock: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fillRule="evenodd" d="M15 0C6.8 0 0 6.8 0 15s6.8 15 15 15 15-6.8 15-15S23.2 0 15 0zm-2.4 21.6l-6.2-6.4L9 12.6l3.6 3.6 7.7-7.7 2.6 2.6-10.3 10.5z" clipRule="evenodd"/></svg>;
};

export default React.memo(InStock);
